import React, { useEffect, useRef, useState } from "react";
import { FaLocationPin } from "react-icons/fa6";
import { IoCall, IoMail } from "react-icons/io5";
import WhatsappIcon from "../assets/media/whatsapp.d026940870fb334920b7.png";
import toast from "react-hot-toast";
import EnquiryFormAPI from "../api/EnquiryFormAPI";

const ContactUs = () => {
  const [tripEnquiry, setTripEnquiry] = useState({
    name: "",
    email: "",
    mobile: "",
    date: "",
    departure: "",
    leaving_from: "",
    duration: "",
  });

  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});

  const handleWhatsappClick = (e) => {
    e.preventDefault();
    const { name, departure, leaving_from, date, duration, email, mobile } =
      tripEnquiry;

    if (
      !name ||
      !departure ||
      !leaving_from ||
      !date ||
      !duration ||
      !email ||
      !mobile
    ) {
      alert("Please fill all fields.");
      return;
    }
    const message = `%0AName: ${name}%0AGoing To: ${departure}%0ALeaving From: ${leaving_from}%0ADeparture Date: ${date}%0ADuration: ${duration} days%0AEmail: ${email}%0AMobile: ${mobile}`;
    const encodedMessage = encodeURIComponent(message);
    const phone = "+917011858174";
    const finalURL = `https://wa.me/${phone}?text=${encodedMessage}`;

    window.open(finalURL, "_blank");
  };

  // TODO : HANDLE INPUT CHANGES
  let handleEnquiryInput = (e) => {
    let { name, value } = e.target;
    setTripEnquiry((prev) => ({ ...prev, [name]: value }));
    // Clear error when user starts typing
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  // Handle field blur to mark as touched
  const handleFieldBlur = (e) => {
    const { name } = e.target;
    setTouched((prev) => ({ ...prev, [name]: true }));
  };

  const validateForm = () => {
    const newErrors = {};
    const nameRegex = /^[A-Za-z ]{2,}$/;
    // Email: only one @, only one . after @, only letters, numbers, @, and .
    const emailRegex = /^[A-Za-z0-9]+@[A-Za-z0-9]+\.[A-Za-z0-9]+$/;
    const mobileRegex = /^[6-9]\d{9}$/;
    const locationRegex = /^[A-Za-z0-9\s,.-]+$/; // Only letters, numbers, spaces, commas, dots, and hyphens

    if (!tripEnquiry.name.trim()) {
      newErrors.name = "Name is required";
    } else if (!nameRegex.test(tripEnquiry.name)) {
      newErrors.name =
        "Please enter a valid name (minimum 2 characters, letters only)";
    }

    if (!tripEnquiry.email) {
      newErrors.email = "Email is required";
    } else {
      // Only one @
      if ((tripEnquiry.email.match(/@/g) || []).length !== 1) {
        newErrors.email = "Email must contain exactly one @";
        // Only one . after @
      } else if (
        (tripEnquiry.email.split("@")[1] || "").split(".").length !== 2
      ) {
        newErrors.email = "Email must contain exactly one . after @";
        // Only allowed characters
      } else if (!emailRegex.test(tripEnquiry.email)) {
        newErrors.email = "Email can only contain letters, numbers, @, and .";
        // . must come after @ and not at the end
      } else if (tripEnquiry.email.endsWith(".")) {
        newErrors.email = "Email cannot end with a dot (.)";
      }
    }

    if (!tripEnquiry.mobile) {
      newErrors.mobile = "Mobile number is required";
    } else if (!mobileRegex.test(tripEnquiry.mobile)) {
      newErrors.mobile =
        "Please enter a valid 10-digit mobile number starting with 6-9";
    }

    if (!tripEnquiry.date) {
      newErrors.date = "Departure date is required";
    } else {
      const selectedDate = new Date(tripEnquiry.date);
      const today = new Date();
      today.setHours(0, 0, 0, 0); // Reset time to start of day for accurate comparison

      if (selectedDate < today) {
        newErrors.date = "Departure date cannot be in the past";
      }
    }

    if (!tripEnquiry.departure.trim()) {
      newErrors.departure = "Destination is required";
    } else if (!locationRegex.test(tripEnquiry.departure)) {
      newErrors.departure =
        "Destination can only contain letters, numbers, spaces, commas, dots, and hyphens";
    }

    if (!tripEnquiry.leaving_from.trim()) {
      newErrors.leaving_from = "Location is required";
    } else if (!locationRegex.test(tripEnquiry.leaving_from)) {
      newErrors.leaving_from =
        "Location can only contain letters, numbers, spaces, commas, dots, and hyphens";
    }

    if (!tripEnquiry.duration) {
      newErrors.duration = "Duration is required";
    } else if (
      isNaN(Number(tripEnquiry.duration)) ||
      Number(tripEnquiry.duration) < 1
    ) {
      newErrors.duration = "Duration must be at least 1 day";
    } else if (Number(tripEnquiry.duration) > 20) {
      newErrors.duration = "Duration cannot be more than 20 days";
    }

    return newErrors;
  };

  let handleEnquiryFormSubmit = async (e) => {
    e.preventDefault();
    // Mark all fields as touched when form is submitted
    setTouched({
      name: true,
      email: true,
      mobile: true,
      date: true,
      departure: true,
      leaving_from: true,
      duration: true,
    });

    const formErrors = validateForm();
    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
      // toast.error("Please correct the form errors.");
      return;
    }
    try {
      const response = await EnquiryFormAPI.postEnquiry(tripEnquiry);
      if (response.code === 200) {
        toast.success("Message Sent Successfully!");
        setTripEnquiry({
          name: "",
          email: "",
          mobile: "",
          date: "",
          departure: "",
          leaving_from: "",
          duration: "",
        });
        setErrors({});
        setTouched({});
      }
    } catch (error) {
      console.error("Submission error:", error);
      toast.error("Something went wrong.");
    }
  };

  // Helper function to render required asterisk
  const renderRequiredAsterisk = () => (
    <span style={{ color: "rgb(236, 12, 34)" }}>*</span>
  );

  return (
    <>
      <section className="custom-contact-us-section pt-5 pb-5 position-relative">
        <div className="container-fluid">
          <div className="row d-flex justify-content-center align-items-center mt-5">
            <div className="col-lg-6 col-xl-6 d-flex justify-content-center align-items-center px-0">
              <div className="custom-connect-card px-4 py-5">
                <h2 className="text-center pb-3">Connect With Us</h2>
                <div className="row">
                  <div className="col-xl-2 d-flex justify-content-center align-items-center fs-2">
                    <FaLocationPin />
                  </div>
                  <div className="col-xl-10 custom-contact-details-header">
                    <h6 className="text-center">Address</h6>
                    <p className="text-center">
                      A-32 1st Floor National Market Peeragarhi New Delhi -
                      110087
                    </p>
                  </div>
                  <div className="col-xl-2 d-flex justify-content-center align-items-center fs-2">
                    <IoMail />
                  </div>
                  <div className="col-xl-10 custom-contact-details-header">
                    <h6 className="text-center">Email address</h6>
                    <p className="text-center">Operations@sortedtrips.in</p>
                  </div>
                  <div className="col-xl-2 d-flex justify-content-center align-items-center fs-2">
                    <IoCall />
                  </div>
                  <div className="col-xl-10 custom-contact-details-header">
                    <h6 className="text-center">Phone</h6>
                    <p className="text-center  d-flex flex-wrap justify-content-center align-items-center gap-3">
                      <span>Ph : +91 89201-93397</span>,
                      <span>Whatsapp : +91 70118-58174</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-xl-6 custom-query-box mt-4 mt-md-4 mt-lg-3 px-0">
              <h2 className="text-center mb-1" style={{ color: "#249acd" }}>
                Have a Query?
              </h2>
              <div className="custom-contact-form mt-3">
                <form onSubmit={handleEnquiryFormSubmit} className="row">
                  <div className="col-xl-6 mb-4">
                    <div className="field-label">
                      Name {renderRequiredAsterisk()}
                    </div>
                    <input
                      type="text"
                      name="name"
                      value={tripEnquiry.name}
                      onChange={handleEnquiryInput}
                      onBlur={handleFieldBlur}
                      className={`form-control ${
                        touched.name && errors.name ? "is-invalid" : ""
                      }`}
                      placeholder="Enter your name"
                    />
                    {touched.name && errors.name && (
                      <div className="error-message">{errors.name}</div>
                    )}
                  </div>
                  <div className="col-xl-6 mb-4">
                    <div className="field-label">
                      Going To {renderRequiredAsterisk()}
                    </div>
                    <input
                      type="text"
                      name="departure"
                      value={tripEnquiry.departure}
                      onChange={handleEnquiryInput}
                      onBlur={handleFieldBlur}
                      className={`form-control ${
                        touched.departure && errors.departure
                          ? "is-invalid"
                          : ""
                      }`}
                      placeholder="Enter destination"
                    />
                    {touched.departure && errors.departure && (
                      <div className="error-message">{errors.departure}</div>
                    )}
                  </div>
                  <div className="col-xl-12 mb-4">
                    <div className="field-label">
                      Leaving From {renderRequiredAsterisk()}
                    </div>
                    <input
                      type="text"
                      name="leaving_from"
                      value={tripEnquiry.leaving_from}
                      onChange={handleEnquiryInput}
                      onBlur={handleFieldBlur}
                      className={`form-control ${
                        touched.leaving_from && errors.leaving_from
                          ? "is-invalid"
                          : ""
                      }`}
                      placeholder="Enter your location"
                    />
                    {touched.leaving_from && errors.leaving_from && (
                      <div className="error-message">{errors.leaving_from}</div>
                    )}
                  </div>
                  <div className="col-xl-6 mb-4">
                    <div className="field-label">
                      Departure Date {renderRequiredAsterisk()}
                    </div>
                    <input
                      type="date"
                      name="date"
                      value={tripEnquiry.date}
                      onChange={handleEnquiryInput}
                      onBlur={handleFieldBlur}
                      min={new Date().toISOString().split("T")[0]}
                      className={`form-control ${
                        touched.date && errors.date ? "is-invalid" : ""
                      }`}
                    />
                    {touched.date && errors.date && (
                      <div className="error-message">{errors.date}</div>
                    )}
                  </div>
                  <div className="col-xl-6 mb-4">
                    <div className="field-label">
                      Duration {renderRequiredAsterisk()}
                    </div>
                    <input
                      type="number"
                      name="duration"
                      value={tripEnquiry.duration}
                      onChange={handleEnquiryInput}
                      onBlur={handleFieldBlur}
                      min="1"
                      max="20"
                      className={`form-control ${
                        touched.duration && errors.duration ? "is-invalid" : ""
                      }`}
                      placeholder="Enter duration in days (max 20)"
                    />
                    {touched.duration && errors.duration && (
                      <div className="error-message">{errors.duration}</div>
                    )}
                  </div>
                  <div className="col-xl-6 mb-3">
                    <div className="field-label">
                      Email {renderRequiredAsterisk()}
                    </div>
                    <input
                      type="email"
                      name="email"
                      value={tripEnquiry.email}
                      onChange={handleEnquiryInput}
                      onBlur={handleFieldBlur}
                      className={`form-control ${
                        touched.email && errors.email ? "is-invalid" : ""
                      }`}
                      placeholder="Enter your email"
                    />
                    {touched.email && errors.email && (
                      <div className="error-message">{errors.email}</div>
                    )}
                  </div>
                  <div className="col-xl-6 mb-3">
                    <div className="field-label">
                      Mobile Number {renderRequiredAsterisk()}
                    </div>
                    <input
                      type="tel"
                      name="mobile"
                      value={tripEnquiry.mobile}
                      onChange={handleEnquiryInput}
                      onBlur={handleFieldBlur}
                      className={`form-control ${
                        touched.mobile && errors.mobile ? "is-invalid" : ""
                      }`}
                      placeholder="Enter your mobile number"
                    />
                    {touched.mobile && errors.mobile && (
                      <div className="error-message">{errors.mobile}</div>
                    )}
                  </div>
                  <div className="col-xl-12 d-flex justify-content-center align-items-center text-center">
                    <button
                      type="submit"
                      style={{
                        backgroundColor: "#f36d21",
                        border: "none",
                        padding: "5px 10px",
                        height: "40px",
                        color: "white",
                      }}
                      className="fs-6 rounded-2"
                    >
                      SEND ENQUIRY
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        <div className="custom-whatsapp-contact">
          <a
            href="#"
            onClick={handleWhatsappClick}
            rel="noopener noreferrer"
            target="_blank"
            className="overflow-hidden"
          >
            <img src={WhatsappIcon} alt="" className="img-fluid m-0" />
          </a>
        </div>
      </section>
    </>
  );
};

export default ContactUs;
